<template>
  <div class="view-container">
    <div class="card">
      <div class="card-header card-header-divider">
        <div class="card-title">Отзыв</div>
      </div>
      <div class="card-body">
        <review-form />
      </div>
    </div>
  </div>
</template>

<script>
import ReviewForm from "../../feature/partners/forms/ReviewForm.vue";
import useCheckRights from "../../mixins/useCheckRights";
export default {
  components: { ReviewForm },
  name: "review-page",
  setup() {
    const { getRight } = useCheckRights();

    return {
      getRight,
    };
  },
};
</script>

<style>
</style>